<template>
  <div class="contextual-menu"
       v-click-away="hideMenuClickAway"
       :class="{'contextual-menu--active':visibility.menu}">
    <div class="contextual-menu__icon"
         ref="toggle"
         @click.stop.prevent="toggleMenu()">
      <SvgEdit/>
    </div>
    <div class="contextual-menu__menu"
         v-show="visibility.menu">
      <div class="contextual-menu__menu__arrow"></div>
      <div class="contextual-menu__menu__inner">
        <slot name="prepend"></slot>
        <div class="menu__link"
             v-if="edit"
             @click.stop.prevent="editLink()">
          Edit
        </div>
        <div class="menu__link"
             v-if="rename"
             @click.stop.prevent="renameLink()">
          Rename
        </div>
        <div class="menu__link"
             v-if="move"
             @click.stop.prevent="moveLink()">
          Move to
        </div>
        <div class="menu__link"
             v-if="copy"
             @click.stop.prevent="copyLink()">
          Copy to
        </div>
        <div class="menu__link"
             v-if="duplicate"
             @click.stop.prevent="duplicateLink()">
          Duplicate
        </div>
        <div class="menu__link"
             v-if="remove"
             @click.stop.prevent="removeLink()">
          Delete
        </div>
        <slot name="append"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mixin as VueClickAway } from 'vue3-click-away';
import SvgEdit from '@/components/svgs/SvgEdit.vue'

/**
 * Generic component used throughout to create a dropdown menu,
 * With certain actions relating to "items" and "folders".
 *
 * Certain props show certain links.
 *
 * Logic happens at parent component level.
 */
export default {
  name: 'ContextualMenu',
  mixins: [VueClickAway],
  components: {
    SvgEdit,
  },
  props: {
    move: false,
    remove: false,
    rename: false,
    copy: false,
    duplicate: false,
    edit: false,
    showCounter: 0,
  },
  data () {
    return {
      visibility: {
        menu: false
      },
      counter: 0,
    }
  },
  watch: {
    showCounter (val) {
      if (val > 0) {
        this.counter = val
        this.visibility.menu = true
      }
    }
  },
  methods: {
    /**
     * Toggle menu on or off.
     */
    toggleMenu () {
      this.visibility.menu = !this.visibility.menu
    },
    /**
     * Turn menu off.
     */
    hideMenuClickAway () {
      if (this.counter > 0) {
        this.counter = 0
      } else {
        this.visibility.menu = false
      }
    },
    /**
     * Turn menu off.
     */
    hideMenu () {
      this.visibility.menu = false
    },
    /**
     * Turn menu on.
     */
    showMenu () {
      this.visibility.menu = true
    },
    /**
     * Click "move" link callback.
     */
    moveLink () {
      this.hideMenu()
      this.$emit('move')
    },
    /**
     * Click "remove" link callback.
     */
    removeLink () {
      this.hideMenu()
      this.$emit('delete')
    },
    /**
     * Click "rename" link callback.
     */
    renameLink () {
      this.hideMenu()
      this.$emit('rename')
    },
    /**
     * Click "copy" link callback.
     */
    copyLink () {
      this.hideMenu()
      this.$emit('copy')
    },
    /**
     * Click "duplicate" link callback.
     */
    duplicateLink () {
      this.hideMenu()
      this.$emit('duplicate')
    },
    /**
     * Click "edit" link callback.
     */
    editLink () {
      this.hideMenu()
      this.$emit('edit')
    }
  }
}
</script>

<style scoped lang="scss">

.contextual-menu {
  position: relative;
  display: inline-block;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 2rem;

  &:hover {
    color: $primary-color;
    border-color: $primary-color;
  }

  .contextual-menu__icon {
    width: 2rem;
    height: 2rem;
    padding: 0.25rem;
    border: 1px solid $main-font-color;
    border-radius: 2rem;
    cursor: pointer;

    :deep(svg) {
      width: 100%;
      height: auto;
      display: block;

      * {
        fill: $main-font-color;
      }
    }
  }

}

.contextual-menu__menu {
  position: absolute;
  top: 2rem;
  right: 0;
  width: 220px;
  z-index: 10;
  color: $main-font-color;
  line-height: 160%;

  .contextual-menu__menu__inner {
    display: block;
    background: #fff;
    padding: 0;
    border-radius: 3px;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    text-align: left;
    line-height: 150%;
    font-weight: 500;

    .menu__link, :deep(.menu__link) {
      cursor: pointer;
      border-bottom: 1px solid #ccc;
      padding: 0.5rem 1rem;

      &:hover {
        background: #eee;
      }

      &:last-child {
        border-bottom: 0;
      }
    }

  }

  .contextual-menu__menu__arrow {
    top: -20px;
    right: 0.35rem;
    content: " ";
    position: absolute;
    height: 10px;
    width: 10px;
    pointer-events: none;
    border: 10px solid rgba(255, 255, 255, 0);
    border-bottom-color: #fff;
  }

}

</style>
